import React, { useEffect, useState } from 'react'
import Modal, { ModalProps } from 'components/modal'
import { IDuplicatedChild } from 'types'
import api from 'helpers/api'
import { useApplicationStore } from 'hooks/application'
import Skeleton from 'components/skeleton'

interface DuplicateChildrenProps extends ModalProps {
  type: 'project' | 'table' | 'process'
  publicId: string
}

const DuplicateChildren: React.FC<DuplicateChildrenProps> = ({ id, open, setOpen, type, publicId }) => {
  const { displayErrorMessage } = useApplicationStore()

  const [loadingDuplicatedChildren, setLoadingDuplicatedChildren] = useState<boolean>(false)
  const [duplicatedChildren, setDuplicatedChildren] = useState<IDuplicatedChild[]>([])

  useEffect(() => {
    if (open) {
      setLoadingDuplicatedChildren(true)
      api
        .getDuplicatedChildren(publicId, type)
        .then((response) => {
          setDuplicatedChildren(response.data)
        })
        .catch((error) => {
          displayErrorMessage(error)
        })
        .finally(() => {
          setLoadingDuplicatedChildren(false)
        })
    }
  }, [open, publicId, type])

  return (
    <Modal id={id} open={open} setOpen={setOpen} title={`${duplicatedChildren.length} Duplicated Resources`}>
      <ul className="p-5">
        {loadingDuplicatedChildren && (
          <div className="flex justify-center items-center h-[100px]">
            <Skeleton className="w-full h-[50px]" />
          </div>
        )}
        {!loadingDuplicatedChildren &&
          duplicatedChildren.length > 0 &&
          duplicatedChildren
            .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
            .map((child) => {
              const duplicateName = child.name
              const duplicatedBy = child.user ? child.user : 'Unknown'
              const duplicatedDate = new Date(child.createdAt + 'Z').toISOString()
              const deletedBy = child.deletedBy ? child.deletedBy : 'Unknown'
              const deletedDate = child.deletedAt ? new Date(child.deletedAt + 'Z').toISOString() : undefined
              return (
                <li key={child.publicId} className="flex flex-row items-center mb-2.5">
                  {child.link ? (
                    <a href={child.link} target="_blank" rel="noreferrer" className="min-w-[200px] max-w-[200px]">
                      {duplicateName}
                    </a>
                  ) : (
                    <span className="min-w-[200px] max-w-[200px]">{duplicateName}</span>
                  )}
                  <div className="text-sm font-secondary ml-4">
                    Duplicated by {duplicatedBy} on {new Date(duplicatedDate).toLocaleString()}.{' '}
                    {deletedBy && deletedDate
                      ? `Archived by ${deletedBy} on ${new Date(deletedDate).toLocaleString()}`
                      : ''}
                  </div>
                </li>
              )
            })}

        {!loadingDuplicatedChildren && duplicatedChildren.length === 0 && (
          <div className="no-duplicated-children">No resources have been duplicated.</div>
        )}
      </ul>
    </Modal>
  )
}

export default DuplicateChildren
